/**
 * SanPlumb — Catálogo de depósitos comerciales (cisterna / tanque / terma)
 *
 * Portado del diseño aprobado (data.jsx → CATALOGO_DEPOSITOS). Referencias del
 * mercado peruano (Eternit, Rotoplas, Sole, Bosch, Rheem). Capacidades en m³
 * (excepto modelos a medida, donde `cap` es texto).
 *
 * §XV: el catálogo flotante de depósitos estaba DIFERIDO post-MVP; se reactiva
 * a pedido del usuario (v1.9).
 */

export type DepositoTipo = 'cisterna' | 'tanque' | 'terma';

export interface DepositoItem {
  id: string;
  marca: string;
  modelo: string;
  /** Capacidad en m³, o texto para modelos a medida ('var'). */
  cap: number | string;
  /** Dimensiones de referencia. */
  dim: string;
  /** Material / especificación eléctrica. */
  mat: string;
}

export const CATALOGO_DEPOSITOS: Readonly<Record<DepositoTipo, readonly DepositoItem[]>> = {
  cisterna: [
    { id: 'cis-1100', marca: 'Eternit', modelo: 'Cisterna 1100 L', cap: 1.1, dim: '0.95×0.95×1.30 m', mat: 'Polietileno' },
    { id: 'cis-2500', marca: 'Rotoplas', modelo: 'Cisterna 2500 L', cap: 2.5, dim: '1.40×1.40×1.35 m', mat: 'Polietileno' },
    { id: 'cis-5000', marca: 'Eternit', modelo: 'Cisterna 5000 L', cap: 5.0, dim: '1.85×1.85×1.50 m', mat: 'Polietileno' },
    { id: 'cis-conc', marca: 'Concreto', modelo: 'Cisterna obra', cap: 'var', dim: 'A medida', mat: 'Concreto armado' },
  ],
  tanque: [
    { id: 'tk-600', marca: 'Rotoplas', modelo: 'Tanque 600 L', cap: 0.6, dim: '0.90×1.10 m (Ø×h)', mat: 'Polietileno' },
    { id: 'tk-1100', marca: 'Eternit', modelo: 'Tanque 1100 L', cap: 1.1, dim: '1.15×1.30 m (Ø×h)', mat: 'Polietileno' },
    { id: 'tk-2500', marca: 'Rotoplas', modelo: 'Tanque 2500 L', cap: 2.5, dim: '1.40×1.65 m (Ø×h)', mat: 'Polietileno' },
    { id: 'tk-5000', marca: 'Eternit', modelo: 'Tanque 5000 L', cap: 5.0, dim: '1.85×2.00 m (Ø×h)', mat: 'Polietileno' },
  ],
  terma: [
    { id: 'tm-50', marca: 'Sole', modelo: 'Terma eléctrica 50 L', cap: 0.05, dim: '0.40×0.65 m', mat: '220 V · 1500 W' },
    { id: 'tm-80', marca: 'Sole', modelo: 'Terma eléctrica 80 L', cap: 0.08, dim: '0.45×0.80 m', mat: '220 V · 2000 W' },
    { id: 'tm-110', marca: 'Bosch', modelo: 'Terma a gas 110 L', cap: 0.11, dim: '0.50×1.00 m', mat: 'GLP · 18 kW' },
    { id: 'tm-150', marca: 'Rheem', modelo: 'Terma eléctrica 150 L', cap: 0.15, dim: '0.55×1.20 m', mat: '220 V · 3000 W' },
  ],
} as const;

/** Defaults de selección por tipo. */
export const DEPOSITO_DEFAULTS: Readonly<Record<DepositoTipo, string>> = {
  cisterna: 'cis-2500',
  tanque: 'tk-1100',
  terma: 'tm-80',
};
